import { Gift, FileText, Video, Headphones } from "lucide-react";

export function Bonus() {
    const bonuses = [
        { icon: FileText, title: "Scripts de Atendimento", value: "R$ 497", desc: "Scripts prontos para converter leads em agendamentos" },
        { icon: Video, title: "Treinamento de Recepção", value: "R$ 997", desc: "Curso completo para capacitar sua equipe" },
        { icon: Headphones, title: "Suporte VIP 30 dias", value: "R$ 597", desc: "Acompanhamento personalizado no primeiro mês" },
    ];

    return (
        <section className="py-20 bg-brand-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <span className="inline-flex items-center gap-2 text-brand-600 font-semibold mb-4">
                        <Gift className="w-5 h-5" />BÔNUS EXCLUSIVOS
                    </span>
                    <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">Você ainda leva de presente</h2>
                    <p className="text-slate-600 text-lg">Materiais complementares para acelerar seus resultados</p>
                </div>
                <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
                    {bonuses.map((b, i) => (
                        <div key={i} className="bg-white rounded-2xl p-6 shadow-lg border-2 border-brand-100">
                            <div className="w-12 h-12 bg-brand-100 rounded-xl flex items-center justify-center mb-4">
                                <b.icon className="w-6 h-6 text-brand-600" />
                            </div>
                            <h3 className="font-bold text-slate-900 mb-2">{b.title}</h3>
                            <p className="text-slate-600 text-sm mb-3">{b.desc}</p>
                            <p className="text-brand-600 font-bold line-through">{b.value}</p>
                        </div>
                    ))}
                </div>
                <div className="mt-12 text-center">
                    <p className="text-2xl font-bold text-brand-600">Total em bônus: R$ 2.091</p>
                    <p className="text-slate-600">100% grátis para você!</p>
                </div>
            </div>
        </section>
    );
}
